import 'css-chunksrc/client/scenes/calendar/weeklyView/timeView/event/styles.scss';export default {
  "eventWrapper": "_eventWrapper_17yrx_1",
  "event": "_event_17yrx_1",
  "background": "_background_17yrx_23",
  "leftBorder": "_leftBorder_17yrx_33",
  "main": "_main_17yrx_42",
  "short": "_short_17yrx_53",
  "name": "_name_17yrx_58",
  "time": "_time_17yrx_77",
  "icon": "_icon_17yrx_85",
  "eventIcon": "_eventIcon_17yrx_95",
  "eventPopupMain": "_eventPopupMain_17yrx_99"
};